<template>
  <div class="privacy row bg-light">
    <div class="col-md-8 col-lg-6 mx-auto my-5">
      <h3 class="mb-4">プライバシーポリシー</h3>

      <!-- 著作権について -->
      <section class="mb-5">
        <h4 class="mb-3">著作権について</h4>
        <p>
          当サイトで掲載している文章や画像などにつきましては、無断転載することを禁止します。<br>
          当サイトは著作権や肖像権の侵害を目的としたものではありません。著作権や肖像権に関して問題がございましたら、お問い合わせページ記載のメールアドレスへご連絡ください。該当箇所の削除など、迅速に対応いたします。
        </p>
      </section>

      <!-- リンクについて -->
      <section class="mb-5">
        <h4 class="mb-3">リンクについて</h4>
        <p>
          当サイトは基本的にリンクフリーです。リンクを行う場合の許可や連絡は不要です。<br>
          ただし、インラインフレームの使用や画像の直リンクはご遠慮ください。<br>
          また、記事中の文章を引用される場合は、必ず引用元・参照元・出典元のURLを記載いただけますよう、お願いいたします。
        </p>
      </section>

      <!-- 免責事項 -->
      <section class="mb-5">
        <h4 class="mb-3">免責事項</h4>
        <p>
          当サイトからのリンクやバナーなどで移動したサイトで提供される情報、サービス等について一切の責任を負いません。<br>
          また当サイトのコンテンツ・情報について、できる限り正確な情報を提供するように努めておりますが、正確性や安全性を保証するものではありません。情報が古くなっていることもございます。<br>
          当サイトに掲載された内容によって生じた損害等の一切の責任を負いかねますのでご了承ください。
        </p>
      </section>

      <!-- Cookieについて -->
      <section class="mb-5">
        <h4 class="mb-3">Cookieについて</h4>
        <p>
          当サイトでは、アクセス解析サービス、各種アフィリエイトプログラム、広告配信サービスを利用しております。<br>
          これらの広告配信業者は、ユーザーのご興味に応じた商品やサービスの広告を表示するため、ユーザーの当サイトおよび他サイトへのアクセスに関する情報Cookieを使用することがございます。<br>
          Cookieは、ユーザーが当サイトあるいは他サイトを閲覧された際、使用されたコンピューターやデバイス内に記録されます。
          ただし、この情報には、お名前・ご住所・メールアドレス・電話番号など個人を特定できるものは一切含まれません。<br>
          Cookieによる情報収集を好まれない場合、ユーザーご自身でブラウザで受け入れを拒否するよう設定することも可能です。
          ただし、この設定により一部のコンテンツが正しく機能しない場合、またサービスが受けられない場合がございます。あらかじめご了承ください。<br>
          なお、設定方法に関しては
          <a href="https://policies.google.com/technologies/partner-sites?hl=ja" target="_blank" rel="noopener">
            Googleポリシーと規約
          </a>
          にてご確認いただけます。
        </p>
      </section>

      <!-- プライバシーポリシーの変更について -->
      <section class="mb-5">
        <h4 class="mb-3">プライバシーポリシーの変更について</h4>
        <p>
          当サイトは、個人情報保護法を遵守し、個人情報の適切な取り扱いに努めます。また、必要に応じてプライバシーポリシーを更新し、最新の情報を提供いたします。<br>
          本プライバシーポリシーは予告なく変更される場合があります。変更があった際には、当サイト上でお知らせいたしますので、定期的にご確認ください。
        </p>
      </section>

      <p class="my-8 text-right">
        2025年2月4日 制定
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Privacy',
  metaInfo: {
    title: 'プライバシーポリシー｜Rhythm Reader',
    meta: [
      {
        vmid: 'description',
        name: 'description',
        content: 'Rhythm Reader（リズムリーダー）のプライバシーポリシー。Cookie、免責事項、著作権について掲載しています。'
      }
    ],
    link: [
      {
        rel: 'canonical',
        href: 'https://rhythm-calculator.colour-field.jp/ja/privacy'
      },
      {
        rel: 'alternate',
        hreflang: 'ja',
        href: 'https://rhythm-calculator.colour-field.jp/ja/privacy'
      },
      {
        rel: 'alternate',
        hreflang: 'en',
        href: 'https://rhythm-calculator.colour-field.jp/privacy'
      },
      {
        rel: 'alternate',
        hreflang: 'x-default',
        href: 'https://rhythm-calculator.colour-field.jp/privacy'
      }
    ]
  },
  components: {}
}
</script>

<style scoped>
.privacy {
  font-family: 'Sawarabi Gothic', sans-serif;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: 400;
}

</style>
